import { InputRoutesConfigObject } from 'single-spa-layout/dist/types/isomorphic/constructRoutes';

import { getDashboardPage } from './pages/getDashboardPage';
import { getLoginPage } from './pages/getLoginPage';

import { getCreativePage } from './pages/getCreativePage';
import { getPlayerManagementPage } from './pages/getPlayerManagementPage';
import { getProfilePage } from './pages/getProfilePage';
import { getPromotionsPage } from './pages/getPromotionsPage';
import { getReportCommissionPage } from './pages/getReportCommissionPage';
import { getReportsPage } from './pages/getReportsPage';
import { getSalesCsPage } from './pages/getSalesCsPage';
import { getStaffManagementPage } from './pages/getStaffManagementPage';

export function getRoutesConfig(): InputRoutesConfigObject {
  return {
    mode: 'history',
    base: '/',
    redirects: {
      '/': '/dashboard',
    },

    routes: [
      {
        type: 'route',
        default: true,
        routes: [
          {
            type: 'div',

            attrs: [
              {
                name: 'class',
                value: 'page',
              },
            ],
            routes: [
              {
                type: 'application',
                name: '@crm/sidebar',
              },
              getReportCommissionPage(),
              getDashboardPage(),
              getSalesCsPage(),
              getReportsPage(),
              getPlayerManagementPage(),
              getStaffManagementPage(),
              getPromotionsPage(),
              getProfilePage(),
              getCreativePage(),
            ],
          },
          {
            type: 'application',
            name: '@crm/footer',
          },
        ],
      },
      getLoginPage(),
      {
        type: 'application',
        name: '@crm/alert',
        props: { position: 'top-center', type: 'TYPE_1' },
      },
      {
        type: 'application',
        name: '@crm/dynamicstream',
      },
    ],
  };
}
